import { useState } from "preact/hooks";
import { convertDateTimeThailand } from "../../../functions";
import { useMessage } from "../../../hooks/useMessage";
import { GET_DEVICES_iNVOICE, POST } from "../../../services/index";
import { IStateInvoice } from "../interfaces/state-invoice";

export const useSearchData = () => {
  const [data, setData] = useState([] as IStateInvoice[]);
  const { openMessage } = useMessage();

  const onSearch = async (invoice: string | null, deviceId?: string | null) => {
    try {
      console.log(`invoice : ${invoice}`)
      console.log(`deviceId : ${deviceId}`)
      const res: any = await POST(GET_DEVICES_iNVOICE, { invoiceID: invoice, deviceID: deviceId });
      const { devices } = res.result;
      const newData: IStateInvoice[] = devices.map(
        (e: IStateInvoice, i: number) => ({
          ...e,
          index: i + 1,
          key: e.deviceID,
          createDate: convertDateTimeThailand(e.createDate),
        })
      );
      if (newData.length === 0) {
        openMessage("error", "ไม่พบข้อมูล");
      }
      if (newData.length > 0) {
        openMessage("success", res.message);
      }
      setData(newData);
    } catch (error) {
      console.log(error);
      openMessage("error", (error as Error).message);
    }
  };
  return {
    data,
    onSearch,
  };
};
